export const ENV = process.env.VUE_APP_BASE_ENV;
export default {
  base_url: process.env.VUE_APP_BASE_URL,
  staffs_center_address: process.env.VUE_APP_STAFFS_CENTER_ADDRESS,
  crm_address: process.env.VUE_APP_CRM_ADDRESS,
  finance_url: process.env.VUE_APP_FINANCE_URL,
  region_address: process.env.VUE_APP_REGION_ADDRESS,
  saas_address: process.env.VUE_APP_SAAS_ADDRESS,
  passport_address: process.env.VUE_APP_PASSPORT_ADDRESS,
  general_address: process.env.VUE_APP_GENERAL_ADDRESS,
  doc_address: process.env.VUE_APP_DOC_ADDRESS,
  approval_address: process.env.VUE_APP_APPROVAL_ADDRESS,
  cards_address: process.env.VUE_APP_CARDS_ADDRESS,
  crm_base_address: process.env.VUE_APP_CRM_BASE_ADDRESS,
  platform: process.env.VUE_APP_PLATFORM,

}


